import { Component, OnInit, EventEmitter, Input, Output, ViewChild, ElementRef, HostListener, ViewChildren, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DaterangePickerComponent } from 'ng2-daterangepicker';
import { RestDataService } from '../../service/rest-data.service';
import { Config } from '../../config/config';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnChanges {
  facetMeta: string;
  filter: string;
  facetTerms: any;
  dateTimeRange: Date[];
  userDomains = [];
  domains = [];
  facetKeyData: string;
  selectedAuthor = null;
  @Input()
  set filterType(filterType: string) {
    this.filter = (filterType && filterType.trim()) || null;
  }

  @Input()
  set facetName(facetName: string) {
    this.facet = (facetName && facetName.trim() !== '') ? facetName : null;
  }
  @Input()
  set facetNameMeta(facetNamemeta: string) {
    this.facetMeta = (facetNamemeta && facetNamemeta.trim() !== '') ? facetNamemeta : null;
  }

  @Input() set facetkey(facetKey: string) {
    this.facetKeyData = (facetKey && facetKey.trim() !== '') ? facetKey : null;
  }

  // @Input()
  // set data(data: any) {
  //   this.facetTerms = data ? data : {};
  // }

  @Input() data : any;

  @Input()
  set displayName(displayName: string) {
    this.name = (displayName && displayName.trim() !== '') ? displayName : null;
  }

  @Input()
  set filterId(filterId: string) {
    this.filter_Id = (filterId && filterId.trim() !== '') ? filterId : null;
  }

  @Output() filterSelect = new EventEmitter<any>();
  dataArray: any[];
  facet: string;
  name: string;
  callFail = false;
  filter_Id: string;
  cssActive: boolean;
  changeEmit = {};
  list = [];
  noresults = false;
  public pageNum = 0;
  searchQuery: FormControl = new FormControl();
  searchQuery2: FormControl = new FormControl();
  searchFocus = false;
  public authorName = [];
  selectedDomains: any[] = [];
  public authorFilterList = [];
  public optionsEconomist: any = {};
  public optionsEconomistArchive: any = {};
  public optionsCricketLiveBlogMatchDate: any = {};
  private model: any = null;
  domain = null;
  domainConfig = null;
  disabledAgencyFeeds = [];
  @ViewChild(DaterangePickerComponent, {static: false})
  private picker: DaterangePickerComponent;
  public options: any = {
    locale: { format: 'YYYY-MM-DD' },
    alwaysShowCalendars: true,
    'opens': 'center'
  };
  modelRadio = { options: 'sponsor' };
  openFilter = false;

  @ViewChild('filterEl', {static: false}) filterElement: ElementRef;
  @ViewChild('filterInput', {static: false}) filterInput: ElementRef;
  @ViewChild('filterList', {static: false}) filterList: ElementRef;
  @ViewChildren('listCheckbox') listCheckbox: ElementRef;
  @ViewChildren('listRadiobox') listRadiobox: ElementRef;
  // @ViewChild('daterange') datepicker: ElementRef;
  @ViewChild(DaterangePickerComponent, {static: false}) private datepicker: DaterangePickerComponent;
  index = 0;
  @Input() isDataKeyValuePair: boolean;
  searchText = '';
  textQuery: FormControl = new FormControl();
  compareOptions = [{"value":"gte","isChecked":false},{"value":"lte","isChecked":false}];

  constructor(
    private config: Config,
    private restService: RestDataService,
    public sharedService: SharedDataService,
    private gaService:GoogleAnalyticsService
    ) {
      const currentDate = new Date();
      const minDateEconomist = new Date(currentDate);
      minDateEconomist.setDate(currentDate.getDate() - 60);
      this.optionsEconomist = {
        locale: { format: 'YYYY-MM-DD' },
        alwaysShowCalendars: true,
        opens: 'center',
        maxDate: currentDate,
        minDate: minDateEconomist,
      };
  
      // Set optionsEconomistArchive with dynamic maxDate from optionsEconomist's minDate
      this.optionsEconomistArchive = {
        locale: { format: 'YYYY-MM-DD' },
        alwaysShowCalendars: true,
        opens: 'center',
        maxDate: minDateEconomist,
      };
      this.optionsCricketLiveBlogMatchDate = {
        locale: { format: 'YYYY-MM-DD' },
        alwaysShowCalendars: true,
        opens: 'center',
        minDate: currentDate,
      };
      this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
      this.disabledAgencyFeeds = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['agencyFeeds']
      && this.domainConfig['config']['agencyFeeds']['filterFieldToDisable']) ? this.domainConfig['config']['agencyFeeds']['filterFieldToDisable'].split(',') : [];

    }

    getDomainConfig(currentDomainConfig) {
      this.domainConfig = currentDomainConfig;
    }

    ngOnChanges(changes: SimpleChanges) {
      this.facetTerms = this.data;
      if(this.filter === 'SectionCheckbox')
      {
        this.list = [];
      }
      if (this.facetTerms) {
        for (const term in this.facetTerms) {
            if(this.filter === 'SectionCheckbox')
            {
                this.authorName.push({ value: term.trim(), isChecked: '' });
                this.list.push({ value: term.trim(), isChecked: '' });
          }
        }
      }
  }

  ngOnInit() {
    this.domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.userDomains = JSON.parse(localStorage.getItem(StaticDataService.allDomains));

    for (const term of this.userDomains) {
      this.domains.push({id: term.id, name: term.name.trim(), isChecked: ''});
    }

    sessionStorage.removeItem('selectedDomains');
    
    this.searchQuery2.valueChanges
      .pipe(debounceTime(300)
      ,distinctUntilChanged())
      .subscribe(result => {
        this.searchText = result;
      });
    if (this.filter === 'api_filter') {
      this.searchQuery.valueChanges
      .pipe(debounceTime(1200)
      ,distinctUntilChanged())
      .subscribe(result => {
        this.searchResults(result, 0, data => {
          this.pageNum = 0;
          this.list = [];
          if (data) {
            this.dataInsertion(data);
            this.noresults = false;
          } else {
            this.noresults = true;
          }
        });
      });
    } else {
      if (this.isDataKeyValuePair) {
        if (this.facetTerms) {
          for (const term of this.facetTerms) {
            if (term.name && term.name.trim() !== '') {
              this.authorName.push({ id: term.id, value: term.name.trim(), isChecked: '' });
              this.list.push({ id: term.id, value: term.name.trim(), isChecked: '' });
            }
          }
        }
      } else if(this.filter === 'comparetextbox')
      {
        this.textQuery.valueChanges
        .pipe(debounceTime(1200),
        distinctUntilChanged())
        .subscribe(result => {
          if(this.compareOptions[0].isChecked)
          {
            this.model = {
              beginEpoc: result,
              formatted: false
            };
            this.createFilterUrl();
          }else if(this.compareOptions[1].isChecked)
          {
            this.model = {
              endEpoc: result,
              formatted: false
            };
            this.createFilterUrl();
          }
        });
      }else if(this.filter === 'singleSelectcheckbox'){
        this.list = this.facetTerms;
      }
       else {
        if (this.facetTerms) {
          for (const term in this.facetTerms) {
            if ((this.disabledAgencyFeeds.indexOf('ht_syndication') > -1) && (term && term.trim() !== '')) {
              if(term !== 'ht_syndication')
              {
                if((this.filter === 'SectionCheckbox' || this.filter === 'checkbox') && this.facet === 'type' && this.facetMeta === 'types' && this.filter_Id === 'format')
                {
                  let value = term.trim()== 'story' ? 'Standard'
                  : term.trim() == 'gallery' ? 'Photo Gallery'
                  : term.trim() == 'liveblog' ? 'Live Blog'
                  : term.trim() == 'HT' ? 'HT'
                  : term.trim() == 'LM' ? 'LM'
                  : term.trim();
                  this.authorName.push({ value:value, keyValue: term.trim(), isChecked: '' });
                  this.list.push({ value:value, keyValue: term.trim(), isChecked: '' });
                }
                else{
                  this.authorName.push({ value: term.trim(), isChecked: '' });
                  this.list.push({ value: term.trim(), isChecked: '' });
                }
              }
            }
            else
            {
              if((this.filter === 'SectionCheckbox' || this.filter === 'checkbox') && this.facet === 'type' && this.facetMeta === 'types' && this.filter_Id === 'format')
              {
                let value = term.trim()== 'story' ? 'Standard'
                : term.trim() == 'gallery' ? 'Photo Gallery'
                : term.trim() == 'liveblog' ? 'Live Blog'
                : term.trim() == 'HT' ? 'HT'
                : term.trim() == 'LM' ? 'LM'
                : term.trim();
                this.authorName.push({ value:value, keyValue: term.trim(), isChecked: '' });
                this.list.push({ value:value, keyValue: term.trim(), isChecked: '' });
              }
              else{
                this.authorName.push({ value: term.trim(), isChecked: '' });
                this.list.push({ value: term.trim(), isChecked: '' });
              }
            }
          }
        }
      }
    }

    this.sharedService.getData().subscribe(x => {
      if (x === 'key27') {
        if (this.filter === 'daterange' && ((document.activeElement === this.filterElement.nativeElement)
        || (this.filterElement.nativeElement.contains(document.activeElement)))) {
         this.datepicker['datePicker'].hide();
       } else {
         if (this.openFilter) {
           this.openFilter = false;
           this.filterElement.nativeElement.focus();
         }
       }
      }
    });

  }
  getDefaultList() {
    if (this.facetTerms) {
      this.list = [];
      for (const term in this.facetTerms) {
        if (term && term.trim() !== '') {
          this.list.push({ value: term.trim(), isChecked: '' });
        }
      }
      this.list = this.list.sort(function(a, b) {
        const nameA = a.value.toUpperCase(); // ignore upper and lowercase
        const nameB = b.value.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      for (let i = 0 ; i < this.authorFilterList.length ; i++) {
        const objIndex = this.list.findIndex(obj => obj.value === this.authorFilterList[i]);
        if (objIndex < 0) {
          this.list.unshift( {value: this.authorFilterList[i], isChecked: true });
        } else {
          this.list[objIndex].isChecked = true;
        }
      }
    }
  }
  dataInsertion(data) {
    for (const term in data) {
      if (term && term.trim() !== '') {
        this.list.push({ value: term.trim(), isChecked: '' });
      }
    }
    for (let i = 0 ; i < this.authorFilterList.length ; i++) {
      const objIndex = this.list.findIndex(obj => obj.value === this.authorFilterList[i]);
      if (objIndex < 0) {
        this.list.unshift( {value: this.authorFilterList[i], isChecked: true });
      } else {
        this.list[objIndex].isChecked = true;
      }
    }
  }
  searchResults(query1, pageNum, callback) {
    const query = query1;
    if (this.config.getEndPoint(this.config.get('views'), 'all_stories', 'dashboard_meta') !== 'false') {
      if (query) {
        let url = this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'all_stories', 'dashboard_meta')
          + '/search?field='+this.facet;
        this.callFail = false;
        url += '&text=' + query.trim();
        this.restService.http_get(url)
          .subscribe(data => {
            this.callFail = false;
            callback(data[this.facetMeta]);
          },
            error => {
              this.callFail = true;
              console.log(error);
            });
      } else {
        this.getDefaultList();
      }
    } else {
      // console.log('url not found');
    }
  }
  onFilterAuthorName() {
    let authorName=[];
    if (this.isDataKeyValuePair) {
      this.authorFilterList = this.list.filter(auth => auth.isChecked).map(auth => auth.id);
      //for google analytics byline name instead of id
      authorName = this.list.filter(auth => auth.isChecked).map(auth => auth.value);
    } else {
      if((this.filter === 'SectionCheckbox' || this.filter === 'checkbox') && this.facet === 'type' && this.facetMeta === 'types' && this.filter_Id === 'format')
      {
        this.authorFilterList = this.list.filter(auth => auth.isChecked).map(auth => auth.keyValue);
      }else{
        if((this.filter === 'domainCheckbox')){
          this.authorFilterList = this.domains.filter(auth => auth.isChecked).map(auth => auth.id);
        }
        else{
        this.authorFilterList = this.list.filter(auth => auth.isChecked).map(auth => auth.value);
        }
      }
    }
    console.log(this.authorFilterList);
    if(this.authorFilterList.length>0){
      let eventCategory='Dashboard';
      let eventAction=sessionStorage.getItem(StaticDataService.tenantName) +" " +this.name ;
      let eventLabel=this.name=='Byline'?authorName:this.authorFilterList;
      let eventValue=null;
     this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
    }
    this.createFilterUrl();
  }

  changeSelected(key)
  {
    if(key == this.selectedAuthor){
      this.selectedAuthor = null;
      this.filterSelect.emit({
        type: this.facet,
        data: ''
      });
    }else{
      this.selectedAuthor = key;
      this.filterSelect.emit({
        type: this.facet,
        data: "&"+this.facet+"="+this.selectedAuthor
      });
    }
    
  }

  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }
   onDateTimeRangeChange(newValue: any) {
    if(newValue.length>0 && newValue[1] !== null){
    let startDate = new Date(newValue[0]);
    let endDate = new Date(newValue[1]);
    const unixTimestampStart = startDate.getTime() / 1000;
    const unixTimestampEnd = endDate.getTime() / 1000;
    this.model = {
      beginEpoc: unixTimestampStart,
      endEpoc: unixTimestampEnd,
      formatted: true
    };
    }else if (newValue.length>0 && newValue[1] === null){
      let startDate = new Date(newValue[0]);
      let endDate = new Date();
      const unixTimestampStart = startDate.getTime() / 1000;
      const unixTimestampEnd = Math.round(endDate.getTime() / 1000);
      this.model = {
        beginEpoc: unixTimestampStart,
        endEpoc: unixTimestampEnd,
        formatted: true
      };
    }
    else{
      this.model = null;
    }
    this.createFilterUrl();
  }
  public selectedDate(value: any, datepicker?: any) {
    this.model = {
      beginEpoc: value.start.unix(),
      endEpoc: value.end.unix(),
      formatted: true
    };

  }
  onRadioAuthorName(obj) {
    this.authorFilterList = [];
    if (obj !== 'none') {
    this.authorFilterList.push(obj);
    let eventCategory='Dashboard';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName) +" " +this.name ;
    let eventLabel= this.authorFilterList;
    let eventValue=null;
    this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
    }
    // this.authorFilterList = this.list.filter(auth => auth.isChecked).map(auth => auth.value);
    console.log(this.authorFilterList);
    this.createFilterUrl();
  }
  public onKeydown(ev) {
    const key = ev.keyCode || ev.charCode;
    this.index = 0;
    if (key === 40) {
      this.listCheckbox['_results'][this.index].nativeElement.focus();
    }
    if (key === 38) {
      this.openFilter = false;
      setTimeout(e => {
        this.filterElement.nativeElement.focus();
      }, 100);
    }
  }

  calendarEventsHandler(e: any, datepicker?: any) {
    console.log(this.name)
    if (e.event.type === 'apply') {
      this.createFilterUrl();
    }
    if (e.event.type === 'cancel') {
      // console.log(this.model);
      this.model = null;
      this.picker.datePicker.setStartDate(new Date());
      this.picker.datePicker.setEndDate(new Date());
      setTimeout(e2 => {
        this.createFilterUrl();
      }, 200);
      e = [];
    }
  }

  checkFocusInside(elem) {
    if (elem && elem.contains(document.activeElement)) {
      return true;
    } else {
      return false;
    }
  }
  updateSelectedDomains() {
    this.selectedDomains = this.domains.filter(d => d.isChecked);
    sessionStorage.setItem('selectedDomains',JSON.stringify(this.selectedDomains.length));
  }

  createFilterUrl() {
    let url = '';
    if (this.model && this.model.formatted) {
      if (this.model.beginEpoc !== this.model.endEpoc) {
        url = ',' + this.facet + '>' + this.model.beginEpoc + '000,' + this.facet + '<' + this.model.endEpoc + '000';
      } else {
        url = ',' + this.facet + '>' + this.model.beginEpoc + '000,' +
          this.facet + '<' + (parseInt(this.model.beginEpoc, 10) + 86400) + '000';
      }
      this.cssActive = true;
      let eventCategory='Dashboard';
      let eventAction=sessionStorage.getItem(StaticDataService.tenantName) +" " +this.name ;
      let eventLabel= url;
      let eventValue=null;
     this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
    } else if(this.model && !this.model.formatted)
    {
      if (this.model.beginEpoc != undefined)
      {
        url = ',' + this.facet + '>' + this.model.beginEpoc;
      }
      if(this.model.endEpoc != undefined)
      {
        url = ',' + this.facet + '<' + this.model.endEpoc;
      }
    } else if ( this.filter === 'radio' && (this.facet === 'toBeAutobacklink'||this.facet==='enable')) {
      url = ',' + this.facet + '%23' + this.authorFilterList.join(',');
    }
    else if(this.filter === 'radio' && this.facet === 'metadata.premiumStory'){
      url = ','+ this.facet + '%23' + this.authorFilterList.join(',');
      this.setCssActive(url)
    }
    else if(this.filter === 'radioForCricketLiveBlog' && this.facet === 'enabled'){
      url = ',' + this.facet + '%23' + this.authorFilterList.join(',');
    }
    else if(this.filter === 'radio' && this.facet === 'genericopenstory'){
      url = ','+ this.facet + '~' + this.authorFilterList.join(',');
      this.setCssActive(url)
    }
    else if(this.filter === 'radio' && this.facet === 'state'){
      url = this.facet + '=' + this.authorFilterList;
      this.setCssActive(url)
    }
    else if(this.filter === 'radio' && this.facet === 'metadata.storyType'){
      url = ','+ this.facet + '%3A' + this.authorFilterList.join(',');
      this.setCssActive(url)
    }
     else if (this.filter === 'social' || this.filter === 'radio') {
      for (const author of this.authorFilterList) {
        url += ',' + this.facet + '.' + author + ':true';
      }
      this.setCssActive(url)
    } 
    else if (this.authorFilterList.length > 0) {
      if (this.facet === 'sitename') {
        url = '&' + this.facet + '=' + this.authorFilterList.join(',');
      } if(this.facetKeyData!=null){
        url = ',' + this.facetKeyData + ':' + this.authorFilterList.join(';');
      } else {
        url = ',' + this.facet + ':' + this.authorFilterList.join(';');
      }
      this.cssActive = true;
    } else {
      this.cssActive = false;
    }
    this.filterSelect.emit({
      type: this.facet,
      data: url
    });
  }
  trackByName(index, instructor) {
    return instructor;
  }

  setCssActive(url) {
    if (url && url.trim() !== '') {
      this.cssActive = true;
    } else {
      this.cssActive = false;
    }
  }

  @HostListener('window:click', ['$event'])
  public hotclick(ev) {
    const clickedComponent = ev.target;
    if (this.filterElement && this.filterElement.nativeElement.contains(clickedComponent)) {
      if (!(this.filterList && this.filterList.nativeElement.contains(clickedComponent))
        && !(this.filterInput && this.filterInput.nativeElement === clickedComponent)) {
          if(this.filter === 'SectionCheckbox'){
            let x = Number(sessionStorage.getItem('selectedDomains'));
           if(x == 1)
             this.openFilter = true;
             else
             this.openFilter = false;
         }else
        this.openFilter = !this.openFilter;
        setTimeout(e => {
          if (this.filterInput && this.openFilter) {
            this.filterInput.nativeElement.focus();
          }
        }, 200);
      }
    } else {
      this.openFilter = false;
    }

  }

  changeComparator(index)
  {
    let value = this.compareOptions[index].value;
    if(index == 0 && this.compareOptions[index].isChecked)
    {
      this.compareOptions[1].isChecked = false;
    }else if(index == 1 && this.compareOptions[index].isChecked)
    {
      this.compareOptions[0].isChecked = false;
    }
    if (this.textQuery.value != null && this.compareOptions[index].isChecked) {
      if (value == "lte") {
        this.model = {
          endEpoc: this.textQuery.value,
          formatted: false
        };
        this.createFilterUrl();
      }
      else if (value == "gte") {
        this.model = {
          beginEpoc: this.textQuery.value,
          formatted: false
        };
        this.createFilterUrl();
      }
    } else if(this.textQuery.value != null && !this.compareOptions[index].isChecked) {
      this.model = null;
      this.createFilterUrl();
    }

  }
}